
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

interface CountryVehicleMapping {
  id: string;
  country_id: string;
  vehicle_type_id: string;
  passenger_count: number;
  luggage_count: number;
  countries: { name_ar: string };
  vehicle_types: { name_ar: string };
}

interface CountryVehicleMappingTableProps {
  mappings: CountryVehicleMapping[];
  onEdit: (item: CountryVehicleMapping) => void;
  onDelete: (id: string) => void;
  isDeleting: boolean;
}

export function CountryVehicleMappingTable({ mappings, onEdit, onDelete, isDeleting }: CountryVehicleMappingTableProps) {
  return (
    <Card>
      <CardContent className="p-0">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>الدولة</TableHead>
              <TableHead>نوع السيارة</TableHead>
              <TableHead className="text-center">عدد المسافرين</TableHead>
              <TableHead className="text-center">عدد الحقائب</TableHead>
              <TableHead>الإجراءات</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {mappings.map((mapping) => (
              <TableRow key={mapping.id}>
                <TableCell className="font-medium">{mapping.countries?.name_ar}</TableCell>
                <TableCell>{mapping.vehicle_types?.name_ar}</TableCell>
                <TableCell className="text-center">{mapping.passenger_count}</TableCell>
                <TableCell className="text-center">{mapping.luggage_count}</TableCell>
                <TableCell>
                  <div className="flex gap-2">
                      <Button variant="outline" size="sm" onClick={() => onEdit(mapping)}>
                          تعديل
                      </Button>
                      <Button variant="destructive" size="sm" onClick={() => onDelete(mapping.id)} disabled={isDeleting}>
                          {isDeleting ? 'جاري الحذف...' : 'حذف'}
                      </Button>
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
